import FJConstant from '../../constants/FJConstant';
import FacebookIcon from '../../assets/svg/facebook-social.svg?react';
import TwitterIcon from '../../assets/svg/twitter-social.svg?react';
// import TumblrIcon from '../../assets/svg/tumblr-social.svg?react';
import ShareIcon from '../../assets/svg/share.svg?react';
import ShareFacebookIcon from '../../assets/svg/share-facebook-new.svg?react';
import ShareTwitterIcon from '../../assets/svg/share-twitter-new.svg?react';
import ShareLinkIcon from '../../assets/svg/share-link-new.svg?react';
import FJAppConstant from '../../constants/FJAppConstant';

export const COLOR_DEFAULT_LIST = [
    '#ffffff',
    '#e4e4e4',
    '#a8a8a8',
    '#000000',
    '#4b5563',
    '#dc2625',
    '#f77171',
    '#fee2e3',
    '#d97709',
    '#fbbf26',
    '#fef3c7',
    '#009669',
    '#31d399',
    '#d1fae5',
    '#00989e',
    '#5be1e6',
    '#b3f7f9',
    '#2663eb',
    '#60a5fa',
    '#dbeafe',
    '#7e38ed',
    '#a78bfa',
    '#ede9fe',
];
export const SHARE_LIST = [
    { type: FJConstant.FACEBOOK, icon: FacebookIcon, newIcon: ShareFacebookIcon, name: 'facebook' },
    { type: FJConstant.TWITTER, icon: TwitterIcon, newIcon: ShareTwitterIcon, name: 'twitter' },
    // { type: FJConstant.TUMBLR, icon: TumblrIcon , name: 'tumblr' },
    { type: FJConstant.COPY_LINK, icon: ShareIcon, newIcon: ShareLinkIcon, name: 'link-copy' },
];
export const SHOW_COMMUNITY_LIST = [
    FJAppConstant.AI_VIDEO_EFFECT,
    FJAppConstant.AI_VIDEO_GENERATOR,
    FJAppConstant.TEXT_TO_IMAGE,
    FJAppConstant.IMAGE_TO_IMAGE,
    FJAppConstant.AI_PHOTO_EDITOR,
];
export const SHOW_GENERATIONS_LIST = [FJAppConstant.IMAGE_EXTENDER];
export const HEADER_TAB_LIST = [
    {
        type: FJConstant.COMMUNITY,
        text: 'community',
    },
    {
        type: FJConstant.CREATIONS,
        text: 'creations',
    },
    {
        type: FJConstant.GENERATIONS,
        text: 'generations',
    },
    {
        type: FJConstant.HISTORY,
        text: 'history',
    },
];
export const LOCAL_STRING_LIST = ['ar', 'cn', 'de', 'en', 'es', 'fr', 'jp', 'pt', 'tw'];
